module.exports = __webpack_public_path__ + "static/fonts/iconfont.723c6fa.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.woff?t=1623981387370
// module id = PD+x
// module chunks = 1